/* 图层第 2 批：多选 / 成组 / 解组（2026-09-13）
   外置原因：section 只剩不到 2KB。
   与 canvas 通过 init(deps) 解耦：deps = {objs, refresh, group, ungroup, done}
   2026-09-13: 解组路径经真机 probe 验证 —— _restoreObjectsState + remove + 逐个 add，
              子对象位置与组前差异为 0 */
(function () {
  'use strict';
  var D = null, multi = false, pick = [];
  function q(id) { return document.getElementById(id); }
  function rev() { return D ? D.objs().slice().reverse() : []; }
  function checkHtml(i) {
    var p = pick.indexOf(i) >= 0;
    return '<button class="pfm-layer-check' + (p ? ' on' : '') + '" data-act="pick" type="button" aria-label="Select">' + (p ? '✓' : '') + '</button>';
  }
  /* 2026-09-19: 图层行第 4 个按钮 = 删除（用户要求，放在改名/眼睛/锁后面）。
     刻意不使用 .pfm-layer-btn 类：section 会给所有 .pfm-layer-btn 绑一套处理
     （未知 act 会落到 else 分支被当成「切换锁」）=> 用独立类 + 自己委托。 */
  function delHtml() {
    return '<button class="pfm-layer-del" data-act="del" type="button" title="Delete" aria-label="Delete">'
      + '<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" style="display:block">'
      + '<path d="M4.5 7h15M9.5 7V4.6h5V7M6.8 7l.85 12.3A1.7 1.7 0 0 0 9.35 21h5.3a1.7 1.7 0 0 0 1.7-1.7L17.2 7M10.3 11v6M13.7 11v6"/>'
      + '</svg></button>';
  }
  function init(deps) {
    if (D) return;
    D = deps;
    var mb = q('pfmLayerMultiBtn');
    if (mb) mb.addEventListener('click', function () { multi = !multi; pick = []; D.refresh(); });
    var gb = q('pfmLayerGroupBtn');
    if (gb) gb.addEventListener('click', function () {
      var objs = rev();
      var kids = pick.slice().sort(function (a, b) { return a - b; })
        .map(function (i) { return objs[i]; }).filter(Boolean);
      if (kids.length < 2) return;
      D.group(kids); pick = []; D.done();
    });
    var ub = q('pfmLayerUngroupBtn');
    if (ub) ub.addEventListener('click', function () {
      var g = rev()[pick[0]];
      if (!g || g.type !== 'group') return;
      D.ungroup(g); pick = []; D.done();
    });
    /* 2026-09-19: 删除按钮走事件委托（图层列表每次重建 innerHTML，逐行绑会丢）。 */
    var list = q('pfmLayersList');
    if (list && !list.__delBound) {
      list.__delBound = true;
      list.addEventListener('click', function (e) {
        var b = e.target && e.target.closest ? e.target.closest('.pfm-layer-del') : null;
        if (!b) return;
        e.preventDefault(); e.stopPropagation();
        var row = b.closest ? b.closest('.pfm-layer-item') : null;
        if (!row) return;
        var o = rev()[parseInt(row.dataset.idx, 10)];
        var c = window.__pfmCanvas;
        if (!o || !c) return;
        try { if (c.getActiveObject() === o) c.discardActiveObject(); } catch (err) { }
        try { c.remove(o); } catch (err) { return; }
        if (c.renderAll) c.renderAll();
        if (D && D.done) D.done();
      });
    }
  }
  function sync() {
    var mb = q('pfmLayerMultiBtn'), gb = q('pfmLayerGroupBtn'), ub = q('pfmLayerUngroupBtn');
    var objs = rev(), only = objs[pick[0]];
    if (mb) { mb.classList.toggle('on', multi); mb.textContent = multi ? 'Done' : 'Multi'; }
    if (gb) gb.style.display = (multi && pick.length >= 2) ? '' : 'none';
    if (ub) ub.style.display = (multi && pick.length === 1 && only && only.type === 'group') ? '' : 'none';
  }
  function toggle(i) {
    var k = pick.indexOf(i);
    if (k >= 0) pick.splice(k, 1); else pick.push(i);
    if (D) D.refresh();
    /* 2026-09-20: 勾选**不触发** canvas 的 selection 事件 ⇒ 主动通知 CopyFace 重算显隐 */
    try{ if(window.__hdCopyFaceSync) window.__hdCopyFaceSync(); }catch(e){}
  }
  /* 2026-09-20: 清空勾选 —— Copy to face 复制到别的面之后调用：
     切面后 pick 里的旧索引会指向目标面上的**另一批**对象，留着会造成误 Group/误删。 */
  function clearPicks() {
    if (!pick.length) return;
    pick = [];
    if (D && D.refresh) D.refresh();
    try{ if(window.__hdCopyFaceSync) window.__hdCopyFaceSync(); }catch(e){}
  }
  window.__hdLayers = {
    init: init, sync: sync, toggle: toggle, clearPicks: clearPicks,
    checkHtml: checkHtml, delHtml: delHtml, multiOn: function () { return multi; },
    isPicked: function (i) { return pick.indexOf(i) >= 0; }
  };
})();
